import { render, staticRenderFns } from "./Pgdb.vue?vue&type=template&id=496b784c&scoped=true"
import script from "./Pgdb.vue?vue&type=script&lang=js"
export * from "./Pgdb.vue?vue&type=script&lang=js"
import style0 from "./Pgdb.vue?vue&type=style&index=0&id=496b784c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b784c",
  null
  
)

export default component.exports